import type { SignupExistingProvider } from '@/api/repository/types/types';
import type { SignupCredentials } from '@/utils/signupIdentity';

/** 가입 이메일 바꾸기 화면 주소 */
export const CLINIC_EMAIL_CHANGE_PATH: string = '/signup/clinic/email-change';

/**
 * 가입 화면 → '가입 이메일 바꾸기' 화면으로 넘기는 값(라우터 상태 — 주소에 남기지 않는다).
 * 새로고침으로 없어지면 그 화면이 가입 첫 화면으로 보낸다.
 */
export interface ClinicEmailChangeRouteState {
    /** 가입 첫 단계에서 인증한 새 이메일 */
    email: string;
    /** 숫자 10자리 */
    businessNumber: string;
    ownerName: string;
    clinicName: string;
    address?: string | null;
    /** 병원 확인이 준 서명 토큰(확인된 병원 후보의 token) — 없으면 null */
    hospitalToken?: string | null;
    /** 지금 가입 이메일(가린 값) — 최종 가입에서 막힌 경우는 없다 */
    maskedEmail?: string | null;
    /** 지금 계정의 가입 방법 — 모르면 null */
    provider?: SignupExistingProvider | null;
    /** 이메일 인증 헤더(소셜 가입이면 X-Signup-Provider·X-Signup-Token) */
    credentials?: SignupCredentials | null;
}

/** 라우터 상태가 이 화면에 쓸 만한 값인지 */
export const isClinicEmailChangeState = (value: unknown): value is ClinicEmailChangeRouteState => {
    const v = value as Partial<ClinicEmailChangeRouteState> | null;
    return !!v && typeof v.email === 'string' && !!v.email && typeof v.businessNumber === 'string' && /^\d{10}$/.test(v.businessNumber)
        && typeof v.ownerName === 'string' && typeof v.clinicName === 'string';
};

export const PROVIDER_LABEL: Record<SignupExistingProvider, string> = {
    EMAIL: '이메일',
    KAKAO: '카카오',
    NAVER: '네이버',
    APPLE: 'Apple',
};

/** "2025-03" → "2025년 3월" (모양이 다르면 null) */
export const joinedYearMonthLabel = (value: string | null | undefined): string | null => {
    const m = /^(\d{4})-(\d{1,2})/.exec(value ?? '');
    return m ? `${m[1]}년 ${Number(m[2])}월` : null;
};
